import { Grid } from '@mui/material';

import CommentSuggestionBox from 'UI/components/CommentSuggestionBox/CommentSuggestionBox';

import BasicInfoTable from '../BasicInfoTable/BasicInfoTable';

const columns = {
  skillName: 'restrict:company_view.skills_name_column',
  suggested: 'restrict:company_view.suggested_expertise_column',
};
const ContentConfirmationDialog = ({ data, comment, managerName }) => {
  return (
    <Grid container spacing={8}>
      <Grid item xs={12}>
        <BasicInfoTable columns={columns} data={data} />
      </Grid>
      {comment && (
        <Grid item xs={12}>
          <CommentSuggestionBox comment={comment} managerName={managerName} />
        </Grid>
      )}
    </Grid>
  );
};

export default ContentConfirmationDialog;
